import { named, withDependencies } from '@wix/thunderbolt-ioc'
import {
	FeatureStateSymbol,
	ILogger,
	LoggerSymbol,
	PageFeatureConfigSymbol,
	SiteFeatureConfigSymbol,
	contextIdSymbol,
} from '@wix/thunderbolt-symbols'
import type { ComponentWillMount, ViewerComponent } from 'feature-components'
import { IFeatureState } from 'thunderbolt-feature-state'
import { ExternalComponentLoaderSymbol, name } from './symbols'
import type {
	IExternalComponentLoader,
	IExternalComponentProps,
	ExternalComponentSecondPhaseRenderComponentIds,
	ExternalComponentSiteConfig,
} from './types'
import { ExternalComponentPageConfig } from './types'

export const ExternalComponentWillMount = withDependencies(
	[
		named(PageFeatureConfigSymbol, name),
		named(SiteFeatureConfigSymbol, name),
		LoggerSymbol,
		ExternalComponentLoaderSymbol,
		named(FeatureStateSymbol, name),
		contextIdSymbol,
	],
	(
		pageConfig: ExternalComponentPageConfig,
		{ disableBYOC }: ExternalComponentSiteConfig,
		logger: ILogger,
		externalComponentLoader: IExternalComponentLoader,
		featureState: IFeatureState<ExternalComponentSecondPhaseRenderComponentIds>,
		contextId: string
	): ComponentWillMount<ViewerComponent<IExternalComponentProps>> => {
		return {
			componentTypes: ['ExternalComponent'],
			async componentWillMount(comp) {
				if (disableBYOC) {
					return
				}
				const compData = pageConfig.externalComponents[comp.id]

				const failedOnSsr = featureState.get()?.failedInSsr?.[comp.id]

				await externalComponentLoader.loadComponentAndUpdateProps({
					comp,
					compData,
					contextId,
					failedOnSsr,
				})
			},
		}
	}
)
